/* eslint-disable no-unused-vars */

import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  user: null,
  error: '',
  loading: false,
  isUserLogout: false,
  isOidcUser: false,
  isOidcLogout: false,
  errorMsg: false,
  hasOidc: false,
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    // --- REVISI: TAMBAHKAN REDUCER UNTUK KONTROL LOADING ---
    showLoader(state, _action) {
      state.loading = true;
      state.error = '';
      state.errorMsg = false;
    },

    hideLoader(state, _action) {
      state.loading = false;
    },
    // ----------------------------------------------------

    apiError(state, action) {
      state.error = action.payload?.data || action.payload || 'Unknown error';
      state.loading = false; // Ini sudah benar
      state.errorMsg = true;
    },

    loginSuccess(state, action) {
      const payload = action.payload;
      state.user = {
        id: payload.id || null,
        name: payload.name || payload.username || 'Unknown',
        email: payload.email || '',
        username: payload.username || '',
        token: payload.token || null,
        firstname: payload.firstname || '',
        role: payload.role || '',
        division: payload.role || '',
        position: payload.position || '',
        photo: payload.photo || null,
        hasOidc: payload.hasOidc ?? false,
        displayName: payload.displayName || '',
      };
      state.loading = false; // Ini sudah benar
      state.errorMsg = false;
      state.isUserLogout = false;
      state.isOidcLogout = false;
      state.isOidcUser = false;
      state.hasOidc = false;
    },

    loginOidcSuccess(state, action) {
      const payload = action.payload;
      state.user = {
        id: payload.id || null,
        name: payload.name || payload.username || 'Unknown',
        email: payload.email || '',
        username: payload.username || 'oidc-user',
        token: payload.token || null,
        firstname: payload.firstname || '',
        role: payload.role || '',
        division: payload.role || '',
        position: payload.position || '',
        photo: payload.photo || null,
        hasOidc: payload.hasOidc ?? true,
      };

      state.loading = false; // Ini sudah benar
      state.errorMsg = false;
      state.isUserLogout = false;
      state.isOidcLogout = false;
      state.isOidcUser = true;
      state.hasOidc = true;
    },

    logoutUserSuccess(state) {
      state.user = null;
      state.isUserLogout = true;
      state.isOidcUser = false;
      state.loading = false; // Ini sudah benar
      state.hasOidc = false;
    },

    logoutOidcSuccess(state) {
      state.user = null;
      state.isUserLogout = true;
      state.isOidcLogout = true;
      state.isOidcUser = true;
      state.loading = false; // Ini sudah benar
      state.hasOidc = false;
    },

    reset_login_flag(state) {
      state.error = '';
      state.loading = false; // Ini sudah benar
      state.errorMsg = false;
      state.isUserLogout = false;
      state.isOidcLogout = false;
    },
  },
});

// --- REVISI: EKSPOR ACTIONS BARU ---
export const {
  apiError,
  loginSuccess,
  loginOidcSuccess,
  logoutUserSuccess,
  logoutOidcSuccess,
  reset_login_flag,
  showLoader, // <-- TAMBAHKAN INI
  hideLoader, // <-- TAMBAHKAN INI
} = loginSlice.actions;

export default loginSlice.reducer;
